import RequestHandler from "./RequestHandler";

function MaterialsAPI() {
    const baseMaterialsAPI = "materials";

    async function getMaterials(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "name";
            const sortDirection = defaultSortDirection || "ASC";
            let URL = `${baseMaterialsAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function addMaterial(item) {
        try {
            const result = await RequestHandler.post(baseMaterialsAPI, item);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateMaterial(updatedObject) {
        try {
            const result = await RequestHandler.put(
                baseMaterialsAPI,
                updatedObject
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteMaterial(id) {
        try {
            const result = await RequestHandler.remove(
                `${baseMaterialsAPI}/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getMaterials,
        addMaterial,
        updateMaterial,
        deleteMaterial,
    };
}

export default MaterialsAPI();
